module.exports = __webpack_public_path__ + "assets/img/trait-icon2.103a74ca.png";